import { render } from "./PriceDetails.vue?vue&type=template&id=474f83aa&ts=true"
import script from "./PriceDetails.vue?vue&type=script&lang=ts"
export * from "./PriceDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__